<app-breadcrumb
  [title]="'Tableau de bord'"
  [items]="['Tableau de bord']"
  [active_item]="'principal'"
></app-breadcrumb>
<div class="container-fluid">
  <div class="row widget-grid" *ngIf="dashboard">
    <div class="col-xxl-4 col-sm-6 box-col-6">
      <app-welcome></app-welcome>
    </div>
    <div class="col-xxl-auto col-xl-3 col-sm-6 box-col-6">
      <div class="row">
        <div class="col-xl-12">
          <app-product-status-chart-box
            [data]="purchase"
          ></app-product-status-chart-box>
          <div class="col-xl-12">
            <app-product-status-chart-box
              [data]="sales"
            ></app-product-status-chart-box>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xxl-auto col-xl-3 col-sm-6 box-col-6">
      <div class="row">
        <div class="col-xl-12">
          <app-product-status-chart-box
            [data]="salesReturn"
          ></app-product-status-chart-box>
          <div class="col-xl-12">
            <app-product-status-chart-box
              [data]="purchaseRate"
            ></app-product-status-chart-box>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xxl-auto col-xl-12 col-sm-6 box-col-6">
      <div class="row">
        <div class="col-xl-12">  <div class="card">
          <div class="card-body">
            <!-- Incorporation de la vidéo YouTube via iframe -->
            <a
              href="portofolio/cv"
              class="btn btn-primary btn-lg"
              target="_blank"
              style="font-size: 16px;"
              ><i class="icon-eye"></i> Mon CV</a
            >
          </div>
        </div></div>
        <div class="col-xl-12">  <div class="card">
          <div class="card-body">
            <!-- Incorporation de la vidéo YouTube via iframe -->
            <a
              href="https://www.youtube.com/watch?v=VytiBxkNiHc"
              class="btn btn-secondary btn-lg"
              target="_blank"
              style="font-size: 16px;"
              ><i class="icon-eye"></i> Certificats</a
            >
          </div>
        </div></div>
      </div>
    
    </div>
    <div class="col-xxl-4 col-md-4 box-col-4 col-ed-4 h-100">
      <div class="card h-100">
        <div class="card-header card-no-border">
          <div class="header-top">
            <h5 class="m-0">Ma présentation</h5>
            <div class="card-header-right-icon">
              <div>
                <!-- Bouton pour visionner la vidéo -->
                <a
                  href="https://www.youtube.com/watch?v=Rx97n3RdvpI&t=92s"
                  class="btn btn-primary"
                  target="_blank"
                  ><i class="icon-eye"></i> Regarder</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="card-body pt-0 campaign-table custom-mb-1">
          <!-- Incorporation de la vidéo YouTube via iframe -->

          <div class="">
            <!-- Affichage de la vidéo -->
            <iframe
              width="100%"
              height="230"
              [src]="sourceUrl"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        
          <!-- <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/VytiBxkNiHc"
            frameborder="0"
            allowfullscreen
          ></iframe> -->
        </div>
      </div>
    </div>

    <div class="col-xxl-4 col-md-6 box-col-6 h-100" *ngIf="dashboard">
      <app-recent-orders [dataPin]="dashboard?.score"></app-recent-orders>
    </div>
  </div>
</div>
